(function(){
	'use strict';
	angular.module('app.supplyChain')
		.controller('procurementAnalysisHistory', procurementAnalysisHistory);
	procurementAnalysisHistory.$inject = ['$rootScope', '$scope', '$timeout', '$state', 'leanFilterService', 'tableRenderService', 'tableService'];

	function procurementAnalysisHistory($rootScope, $scope, $timeout, $state, leanFilterService, tableRenderService, tableService) {

		var vm = this;
		$scope.filterService = leanFilterService;
		var reportSettingsName = 'ProcurementHistory';
		// Extra query params to send to backend in data requests
		var extraParams = [{
			excelReportName: 'ProcurementHistory'
		}];
		var rendererParams = {};
		// Extra drilldown query params to parse
		var extraFilters = [];
		var pinnedColumns = [];
		var isSupplierPortal = (globalConfig.user.role === 'Supplier');
		var defaultFilters = isSupplierPortal ? [] : [{ 'id': 'supplierNdx', 'values': [$scope.filterService.leanDnaAllSelected] }];
		var reportSettingsId = $state.params.reportId;
		
		vm.showExcel = true;

		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.broadcastExcel = broadcastExcel;
		vm.reportName = 'Procurement Analysis History';


		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.getData(params, extraParams).then(function (response) {
				return response;
			});
		}

		init();

		var columns = [
			{ 'id': 'actionStatus', 'display': 'Task Status', 'renderer': tableRenderService.status, 'sort': false, 'width': 100},
			{ 'id': 'itemCode', 'display': 'Item Code', 'renderer': tableRenderService.itemCode, 'width': 200},
			{ 'id': 'dateLog', 'display': 'Log Date', 'renderer': tableRenderService.dateRenderer, 'width': 100},
			{ 'id': 'erpOrderPolicy', 'display': 'ERP Order Policy', 'width': 100},
			{ 'id': 'supplierName', 'display': 'Supplier', 'sort': false, 'width': 150},
			{ 'id': 'supplierCode', 'display': 'Supplier Code', 'sort': false, 'width': 150},
			{ 'id': 'minLevel', 'display': 'Min Level', 'renderer': tableRenderService.minmaxLevelRenderer, 'width': 100},
			{ 'id': 'maxLevel', 'display': 'Max Level', 'renderer': tableRenderService.minmaxLevelRenderer, 'width': 100},
			{ 'id': 'onHandQuantity', 'display': 'On Hand Qty', 'renderer': tableRenderService.integer, 'width': 100},
			{ 'id': 'onOrderQuantity', 'display': 'On Order Qty', 'renderer': tableRenderService.integer, 'width': 100},
			{ 'id': 'unitPrice', 'display': 'Unit Price', 'renderer': tableRenderService.currency, 'width': 100},
			{ 'id': 'avgDailyDemand', 'display': 'Average Demand (Daily)', 'period': 'daily', 'usingOrders': isSupplierPortal, 'renderer': tableRenderService.avgPeriodicDemand, 'width': 100},
			{ 'id': 'reorderPointEffectiveDate', 'display': 'Min Max Effective Date', 'renderer': tableRenderService.minmaxEffectiveDateRenderer, 'width': 100}
		];

		var meta = {
			reportSettingsName: reportSettingsName,
			reportName: vm.reportName,
			reportUrl: '{0}/ProcurementHistoryReport',
			noPaging: false,
			columns: columns,
			pinnedColumns: pinnedColumns,
			defaultSort: 'dateLog',
			defaultSortDirection: 'desc',
			extraParams: extraParams,
			rendererParams: rendererParams,
			pageSize: 50,
			searchType: 'item',
			hideSearch: false,
			setColumnDefaults: true
		};
 
		function init() {
			$scope.filterService = leanFilterService;
			$scope.filterService.clearFilters();
			$scope.filterService.useFactoryFilter = true;
			var siteFilter = leanFilterService.filterDefinitions['Factory'];
			siteFilter.type = 'singleSelect';
			siteFilter.removable = false;
			$scope.filterService.setMasterSingleSelectFilterList([siteFilter]);

			if (isSupplierPortal) {
				$scope.filterService.setMasterFilterList([
					$scope.filterService.filterDefinitions['ERP Order Policy']
				]);
			} else {
				$scope.filterService.setMasterFilterList([
					$scope.filterService.filterDefinitions['Supplier'],
					$scope.filterService.filterDefinitions['ERP Order Policy']
				]);
			}
			$scope.filterService.setMasterRangeFilterList([
				$scope.filterService.filterDefinitions['LogDate']
			]);
			$scope.filterService.setMasterStringFilterList([]);

			$scope.filterService.defaultFilters = defaultFilters;
			$scope.filters = $scope.filterService.masterFilterList;
			$scope.rangeFilters = $scope.filterService.masterRangeFilterList;
			$scope.stringFilters = $scope.filterService.masterStringFilterList;
			$scope.singleSelectFilters = $scope.filterService.masterSingleSelectFilterList;
		}

		function broadcastExcel() {
			$rootScope.$broadcast('export-excel', {doChooseColumns: false, exportFileName: reportSettingsId ? vm.reportName : undefined});
		}
	}

})();
